var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgP2PSent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5498_26",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5498_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9135 17.2115L4.90615 16.5L4.898 15.7115H19.0865L17.9115 14.5213L18.75 13.6828L21.5288 16.4615L18.75 19.2405L17.9115 18.402L19.102 17.2115H4.9135ZM2.5 12.3078V11.954C2.5 11.5988 2.5955 11.2818 2.7865 11.003C2.9775 10.7242 3.23908 10.511 3.57125 10.3635C3.98525 10.1867 4.415 10.0498 4.8605 9.95301C5.306 9.85617 5.76917 9.80776 6.25 9.80776C6.73083 9.80776 7.194 9.85617 7.6395 9.95301C8.085 10.0498 8.51475 10.1867 8.92875 10.3635C9.26092 10.511 9.5225 10.7242 9.7135 11.003C9.9045 11.2818 10 11.5988 10 11.954V12.3078H2.5ZM14 12.3078V11.954C14 11.5988 14.0955 11.2818 14.2865 11.003C14.4775 10.7242 14.7391 10.511 15.0712 10.3635C15.4852 10.1867 15.915 10.0498 16.3605 9.95301C16.806 9.85617 17.2692 9.80776 17.75 9.80776C18.2308 9.80776 18.694 9.85617 19.1395 9.95301C19.585 10.0498 20.0148 10.1867 20.4288 10.3635C20.7609 10.511 21.0225 10.7242 21.2135 11.003C21.4045 11.2818 21.5 11.5988 21.5 11.954V12.3078H14ZM6.25 8.50001C5.76417 8.50001 5.351 8.32984 5.0105 7.98951C4.67017 7.64917 4.5 7.23601 4.5 6.75001C4.5 6.26417 4.67017 5.85109 5.0105 5.51076C5.351 5.17026 5.76417 5.00001 6.25 5.00001C6.73583 5.00001 7.149 5.17026 7.4895 5.51076C7.82983 5.85109 8 6.26417 8 6.75001C8 7.23601 7.82983 7.64917 7.4895 7.98951C7.149 8.32984 6.73583 8.50001 6.25 8.50001ZM17.75 8.50001C17.2642 8.50001 16.851 8.32984 16.5105 7.98951C16.1702 7.64917 16 7.23601 16 6.75001C16 6.26417 16.1702 5.85109 16.5105 5.51076C16.851 5.17026 17.2642 5.00001 17.75 5.00001C18.2358 5.00001 18.649 5.17026 18.9895 5.51076C19.3298 5.85109 19.5 6.26417 19.5 6.75001C19.5 7.23601 19.3298 7.64917 18.9895 7.98951C18.649 8.32984 18.2358 8.50001 17.75 8.50001Z",
    fill: "#15182C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2PSent);
export default __webpack_public_path__ + "static/media/p2p-sent.201f78b23a08cf00a680e1be8740fd5c.svg";
export { ForwardRef as ReactComponent };